import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./MeetPoint.module.scss";
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { v4 } from "uuid";
import * as YStyled from '../../../Styleds';
import PlacesInput from "./PlacesInput";
import { borderWidth } from "polished";
const MeetPoint = ({ meetPlace, set_meetPlace, rewildingObj, type = 2,placeholder="想在哪裡碰面？輸入集合點" }) => {
    useEffect(() => {
        console.log("MeetPoint data", meetPlace,rewildingObj);
        
    }, [meetPlace])
    return (
        <div className={style.meetPlace}>
            {
                (rewildingObj.rewilding_name!=="") ?
                    <img src="./assets/ui/meetPlaceEnabled.png" />
                    :
                    meetPlace.name === "" ?
                        <img src="./assets/ui/meetPlace.png" />
                        :
                        <img src="./assets/ui/meetPlaceEnabled.png" />
            }
            <div>
                <PlacesInput type={type} placeholder={placeholder} initKeyWord={meetPlace.name} style={{borderWidth:"0px"}} onSelect={prediction=>{
                    console.log("predictionprediction",prediction);
                    set_meetPlace({name:prediction.name,"lat":prediction.geometry.location.lat(),"lng":prediction.geometry.location.lng()} );
                }}/>
                <YStyled.Label style={{ background: "#F4F4F4", padding: ".4rem .8rem" }}>
                    <YStyled.Input size={17} placeholder="" value={rewildingObj?.rewilding_name} readOnly={true}></YStyled.Input>
                </YStyled.Label>
            </div>
        </div>
    );

}

export default MeetPoint;